import { render, staticRenderFns } from "./webNewsUpdate.vue?vue&type=template&id=53fbb914&scoped=true&"
import script from "./webNewsUpdate.vue?vue&type=script&lang=js&"
export * from "./webNewsUpdate.vue?vue&type=script&lang=js&"
import style0 from "./webNewsUpdate.vue?vue&type=style&index=0&id=53fbb914&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53fbb914",
  null
  
)

export default component.exports